import { render, staticRenderFns } from "./DisplayAddressCard.vue?vue&type=template&id=b097fcde&scoped=true&"
import script from "./DisplayAddressCard.vue?vue&type=script&lang=js&"
export * from "./DisplayAddressCard.vue?vue&type=script&lang=js&"
import style0 from "./DisplayAddressCard.vue?vue&type=style&index=0&id=b097fcde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b097fcde",
  null
  
)

export default component.exports